import { Switch } from '@components/index';
import { FormDataType } from '@types';

import AttendanceSection from '../../v1/attendance-section/AttendanceSection';

interface AttendanceDetailsSectionProps {
  formData: FormDataType;
  onInputChange: (field: string, value: any) => void;
  handleSwitchClick: (status: boolean) => void;
}

const AttendanceDetailsSection = ({
  formData,
  onInputChange,
  handleSwitchClick
}: AttendanceDetailsSectionProps) => (
  <div className="rounded-xl border border-cofeeGreyBlue4 bg-white pb-6 pt-4">
    <div className="grid gap-y-4">
      <h3 className="border-b border-cofeeGreyBlue4 px-6 pb-4 text-lg font-semibold text-cofeeNeutral11">
        Attendance details
      </h3>
      <div className="flex items-start justify-start gap-2 px-6">
        <Switch
          handleClick={handleSwitchClick}
          value={formData?.isAttandanceTrackingEnabled}
          className="mt-0.5"
        />
        <div className="flex flex-col">
          <span className="text-base font-medium text-cofeeNeutral11">
            Enable attendance
          </span>
          <span className="text-sm text-grey">
            Ensuring accurate tracking of student attendance for better
            engagement and accountability.
          </span>
        </div>
      </div>
      <div className="px-6">
        {formData?.isAttandanceTrackingEnabled && (
          <AttendanceSection
            onInputChange={onInputChange}
            workingDays={formData.workingDays}
            isSmsAlertEnabled={formData.isSendAttendanceAlertEnabled}
            className="!mt-0"
          />
        )}
      </div>
    </div>
  </div>
);

export default AttendanceDetailsSection;
